import React, { Component } from 'react'

class ErrorBoundary extends Component {

  state = { hasError: false }

  static getDerivedStateFromError (error) {
    return { hasError: true }
  }

  render() {
    if (this.state.hasError) {
      return <div>Unser Team hat wohl etwas falsch gemacht ¯\_(ツ)_/¯</div>
    }

    return this.props.children
  }
}

export default ErrorBoundary
